import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
import SearchParams from '@/_constants/SearchParams.ts';

const SandboxPage: FC = () => {
  const navigate = useNavigate();

  const handleGoToPaymentPage = () => {
    navigate(
      passToRouteSearchParams(Routes.PAYMENT_SELECT, {
        [SearchParams.REDIRECT_URL]: encodeURIComponent(window.location.href),
      })
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <button onClick={handleGoToPaymentPage}>goToPaymentPage</button>
      <button
        onClick={() => {
          throw new Error('This is your first error!');
        }}
      >
        Break the world
      </button>
      <ul>
        <li>qwe</li>
      </ul>
    </div>
  );
};

export default SandboxPage;
